import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, unwrap } from "@/shared/api/client";
import type { ApiError } from "@/shared/api/errors";
import { metaKeys } from "@/shared/api/query-keys";
import type { components } from "@/shared/api/generated";

/** Type dérivé du contrat OpenAPI — jamais réécrit à la main (docs/24 §3). */
export type Meta = components["schemas"]["MetaResponse"];

/**
 * Interroge `/api/v1/meta`.
 *
 * Sert de sonde de bout en bout : si ce hook réussit, la chaîne navigateur →
 * Vite → API → configuration est fonctionnelle.
 */
export function useMeta(): UseQueryResult<Meta, ApiError> {
  return useQuery<Meta, ApiError>({
    queryKey: metaKeys.all,
    queryFn: () => unwrap(api.GET("/api/v1/meta")),
  });
}
